import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../utils/Hooks";
import { useNavigate } from "react-router-dom";
import { LoggedInView } from "../common/LoggedInView";
import Breadcrumbs from "../common/Breadcrumbs";
import ElogInput from "../common/form/ElogInput";
import { BreadcrumbLink } from "../../models/BreadcrumbLink";
import { Link, useParams } from "react-router-dom";
import {
    createSMSSender,
    resetCreateSMSSenderStatus,
} from "../../store/reducers/SMSSendersSlice";
import { RequestStatus } from "../../utils/Enums";
import {FormikProvider, useFormik, Form} from "formik";

interface NewSMSSenderScreenProps {}

export interface NewSMSSenderFormProps {
    name: string;
}

export const NewSMSSenderScreen: React.FC<NewSMSSenderScreenProps> = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const SMSSendersState = useAppSelector(
        (state) => state.SMSSenders
    );

    const requestStatus: RequestStatus =
        SMSSendersState.createSMSSenderStatus;

    const breadcrumbLinks: BreadcrumbLink[] = [
        { text: "SMSi saatjad", url: "/sms-senders" },
        { text: "Lisa uus SMSi saatja", url: "/sms-senders/new" },
    ];

    useEffect(() => {
        if (requestStatus === RequestStatus.Success) {
            dispatch(resetCreateSMSSenderStatus());
            navigate(breadcrumbLinks[0].url);
        }
    }, [requestStatus]);

    // @ts-ignore
    const formik = useFormik({
        initialValues: {
        },
        onSubmit: (values: any) => {
            dispatch(createSMSSender(values));
        },
        enableReinitialize: true
    });

    const {values, setFieldValue, handleSubmit} = formik;

    return (
        <LoggedInView fullWidth={false}>
            <Breadcrumbs links={breadcrumbLinks} />
            {requestStatus === RequestStatus.Failed &&
            SMSSendersState.errors.length > 0 && (
                <div className="message msg-error">
                    <div>
                        <h2>Viga:</h2>
                        {SMSSendersState.errors.map(
                            (error, index) => (
                                <span key={index}>
                                        {error}
                                    <br />
                                    </span>
                            )
                        )}
                    </div>
                </div>
            )}
            <FormikProvider value={formik}>
                <Form onSubmit={handleSubmit}>
                    <div className="form">
                        <h2>
                            <span>SMSi saatja andmed</span>
                        </h2>
                        <table className="form">
                            <tbody>
                            <ElogInput
                                label="Nimi"
                                name="name"
                                mandatory={true}
                            />
                            </tbody>
                        </table>
                    </div>
                    <div className="action clear">
                        <p>
                            <button type="submit">
                                    <span>
                                        <strong>Sisesta</strong>
                                    </span>
                            </button>
                            <Link to="/offline-reasons">Tühista</Link>
                        </p>
                    </div>
                </Form>
            </FormikProvider>
        </LoggedInView>
    );
};